import { render, staticRenderFns } from "./CheckBoxItem.vue?vue&type=template&id=57eb67d2&"
import script from "./CheckBoxItem.vue?vue&type=script&lang=js&"
export * from "./CheckBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports